<template>
    <div>
        <admin-panel-filters :filter="filter" :page="page" :status="status" @setStatus="setStatus">

        </admin-panel-filters>
        <demo-requests-table :demoRequests="demoRequests" :totalPages="totalPages" :page="page" :status="status"
            @setPage="setPage"></demo-requests-table>
    </div>
</template>

<script>
    import moment from 'moment';
    import helpers from '@/helpers.js';
    import DemoRequestsTable from './demo_requests_table';
    import adminPanelFilters from "../adminPanelFilters";

    var start = moment().add(1, 'week').startOf('week').toDate();
    var end = moment().add(1, 'week').endOf('week').toDate();
    var from = moment(String(start)).format('YYYY-MM-DD');
    var to = moment(String(end)).format('YYYY-MM-DD');

    export default {
        components: {
            adminPanelFilters,
            DemoRequestsTable,

        },


        data: function () {
            return {
                page: 0,
                status: 9,
                filter: 'nextweek',
                st: ''
            }
        },
        computed: {
            demoRequests: function () {
                if (localStorage.getItem('st') != undefined) {
                    this.st = localStorage.getItem('st');
                } else {
                    this.st = 0;
                }
                return this.$store.getters['users/demoRequests'];
            },
            totalPages: function () {
                return this.$store.getters['users/totalPages'];
            }
        },


        created: function () {
            this.page = helpers.getPageQuery();
        },


        watch: {
            page: function (val) {
                let self = this;
                this.$store.dispatch('users/getAllDemoRequests', [val, self.status, '', '', from, to, '', '', '', this.st]);
            }
        },


        methods: {
            setPage(page) {
                this.page = page;
                this.$router.push('demo-leads-schedule?page=' + page);
            },
            setStatus(status) {
                this.status = status;
            },
        }
    }
</script>
<style>
    .overlay {
        opacity: 0.3 !important;
    }

    .custom {

        text-align: center;
        position: absolute;
        z-index: 999;
        top: 246px;
        left: 500px;
        opacity: 0.0.5;
    }
</style>